var BillingPeriod = /* @__PURE__ */ function(BillingPeriod2) {
  BillingPeriod2["Monthly"] = "month";
  BillingPeriod2["Yearly"] = "year";
  BillingPeriod2["ThreeYears"] = "year_3";
  return BillingPeriod2;
}({});

export { BillingPeriod };
//# sourceMappingURL=pricing.types.js.map
